import React from 'react';
// Now using the new IS-filtered allocation grid (much more performant!)
import ISAllocationGridPage from './ISAllocationGridPage';

// Old versions kept for reference:
// import ConsolidatedAllocationGridMinimal from './ConsolidatedAllocationGrid-Minimal';
// import ConsolidatedAllocationGrid from './ConsolidatedAllocationGrid';
// import { GridViewProvider } from './GridViewContext';

const ConsolidatedAllocationPage: React.FC = () => {
  return <ISAllocationGridPage />;
};

export default ConsolidatedAllocationPage;
